<div class="body">

    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">switch_access_shortcut_add</mat-icon>
        <span>
            E-Mail wiederherstellen
        </span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <div class="mail-wrapper" *ngFor="let mail of (mails$|async)">

            <div class="mail-inner">
                <app-mail-label [mail]="mail"></app-mail-label>
            </div>

            <button mat-raised-button color="primary" (click)="recoverMail(mail)">
                Wiederherstellen
            </button>

        </div>

    </div>

    <div class="footer">
        {{(mails$|async)? (mails$|async).length: 0}} von {{totalItems}}
        <span *ngIf="(mails$|async)?.length < totalItems" class="load-more" (click)="loadMore()">Mehr laden</span>
    </div>

    <div *ngIf="loading$|async" @show class="overlay">

        <mat-spinner [diameter]="50"></mat-spinner>

    </div>

</div>
